export const trimIndent = (s, indent) => {
    const regex = new RegExp(`^\\s{${indent}}`);
    return s
        .split('\n')
        .map((l) => l.replace(regex, ''))
        .join('\n');
};
